















import Vue from 'vue';

export default Vue.extend({
    data() {
        return {
        };
    },
    methods: {
        close() {
            this.$emit('selectTool', { id: -1 });
        },
    },
});
